const BASE = '';  // same origin; CRA proxy forwards to :3001 in dev

async function get(url) {
  const r = await fetch(BASE + url);
  if (!r.ok) {
    const text = await r.text().catch(() => r.status);
    throw new Error(text || r.status);
  }
  return r.json();
}

export const api = {
  stats:          ()            => get('/api/stats'),
  dashboard:      ()            => get('/api/dashboard'),
  battles:        ()            => get('/api/battles'),
  currentBattle:  ()            => get('/api/battles/current'),
  standings:      (id)          => get(`/api/battles/${id}/standings`),
  battleStats:    (id)          => get(`/api/battles/${id}/battle-stats`),
  timeline:       (id)          => get(`/api/battles/${id}/timeline`),
  clanPlayers:    (bid, cid)    => get(`/api/battles/${bid}/clans/${cid}/players`),
  playerSearch:   (q)           => get(`/api/players/search?q=${encodeURIComponent(q)}`),
  player:         (id)          => get(`/api/players/${id}`),
  playerStats:    (rid, bid)    => get(`/api/players/${rid}/battle/${bid}/stats`),
  playerTimeline: (rid, bid)    => get(`/api/players/${rid}/battle/${bid}/timeline`),
  clans:          ()            => get('/api/clans'),
  clanHistory:    (id)          => get(`/api/clans/${id}/history`),
  clanForm:       (id, limit=5) => get(`/api/clans/${id}/form?limit=${limit}`),
  clanBattleDetail: (cid, bid)  => get(`/api/clans/${cid}/battle/${bid}/detail`),
  clanInfo:       (name, battle)=> get(`/api/clan-info/${encodeURIComponent(name)}${battle ? `?battle=${encodeURIComponent(battle)}` : ''}`),
  top50:          ()            => get('/api/top50'),
  top50Trend:     (clans, hrs)  => get(`/api/top50/trend?clans=${encodeURIComponent(clans)}&hours=${hrs ?? 48}`),
  disconnects:    (limit, battleId) => {
    const p = new URLSearchParams();
    if (limit)    p.set('limit',    limit);
    if (battleId) p.set('battleId', battleId);
    const qs = p.toString();
    return get(`/api/disconnects${qs ? '?' + qs : ''}`);
  },
  thumbnails:     (ids)         => get(`/api/roblox/thumbnails?ids=${encodeURIComponent(ids)}`),
  globalClanPlayers: ()         => get('/api/global/clans/players'),
  globalPlayer:      (userId)   => get(`/api/global/clans/players/${userId}`),
  globalBattle:      (battleId) => get(`/api/global/clans/battles/${encodeURIComponent(battleId)}`),
};
